



















































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import tenantNavMixin from '@/mixins/tenant-nav-mixin'
export default Vue.extend({
    mixins: [tenantNavMixin],
    data() {
        return {
            email: null,
            loading: false,
            name: null,
            step: 1
        }
    },
    mounted() {
        if (!this.resellerLink && this.reseller) {
            this.$store.dispatch('resellerGet')
        }
    },
    computed: {
        ...mapGetters(['resellerLink', 'token']),
        resellText(): string {
            return this.resellerLink ? 'Reset' : 'Get'
        },
        reseller(): object {
            return this.$store.getters.user.reseller
        }
    },
    methods: {
        back(): void {
            //  Reset the form
            this.email = null
            this.name = null

            //  Nav to step 1
            this.step = 1
        },
        close(): void {
            //  Reset the form
            this.email = null
            this.name = null

            //  Close the app dialog
            this.$store.dispatch('dialogClose', 'APP')
        },
        copy(): void {
            let txt = document.getElementById('reseller-link') as HTMLInputElement
            txt.select()
            txt.setSelectionRange(0, 99999)
            document.execCommand('copy')
            this.$store.commit('appNotificationBarSet', {
                message: 'Reseller Link Copied to Clipboard!',
                type: 'success'
            })
        },
        async getLink(): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            const link = await this.$store.dispatch('resellerGet')

            //  Stop the loading spinner
            this.loading = false

            if (!link) return

            return link
        },
        async submit(): Promise<void> {
            //  Validate the form
            const valid = await this.$validator.validate()

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  Start the loading spinner
            this.loading = true

            //  Post the tenant to the API
            const invited = await this.$store.dispatch('resellerPost', {
                email: this.email
            })

            //  Stop the loading spinner
            this.loading = false

            //  Close the app dialog
            this.close()

            this.$store.commit('appNotificationBarSet', {
                message: 'Your workspace invite has been successfully sent out.',
                type: 'success'
            })
        },
        async submitWorkspace(): Promise<void> {
            //  Advance to the next step
            this.step = 2

            //  Assemble a tenant payload
            const tenant = { company_name: this.name }

            //  Start the loading spinner
            this.loading = true

            //  Post the tenant to the API
            const newTenant = await this.$store.dispatch('tenantPost', tenant)

            //  If the tenant was NOT created, return to step 1
            if (!newTenant) return this.back()

            //  Since the user is already logged in they should have a two_factor_token set and auth token
            const twoFactorToken = localStorage.getItem('two_factor_token')
            const userToken = localStorage.getItem('token')

            //  Else, fetch the auth user again to refresh the user's memberships
            const user = await this.$store.dispatch('authUserGet', {'userToken': userToken, 'twoFactorToken': twoFactorToken})

            //  Get the memberships async
            this.$store.dispatch('tenantMembershipsGet')

            //  Stop the loading spinner
            this.loading = false

            //  Close the app dialog
            this.close()

            //  Route the user into their new workspace
            this.goToTenant(newTenant.id)
        }
    }
})
